/**
 * The chat socket sends `{ type: 'RECONNECT' }` to a socket it cannot identify:
 * one opened before it required a ticket. Closing with any code but 1000 makes
 * useWebSocket reconnect, and so open a new socket with a fresh ticket. (The
 * socket cannot close it for us: a close from its end arrives as 1000, the one
 * code useWebSocket takes as final.)
 */
export const RECONNECT_CLOSE_CODE = 4000;

export const isReconnectRequest = (event) => {
  try {
    return JSON.parse(event?.data)?.type === 'RECONNECT';
  } catch (error) {
    return false;
  }
};
